import React from "react";
import Navbar from "./Navbar";
import Bottombar from "./Bottombar";
import Hero from "./Hero";
import heroImage from "../Website/5101597.jpg";
import { Mail, MapPin, Clock } from "lucide-react";
import "./Clients.css";
import "./Services.css";

function ContactForm() {
  return (
    <div className="clients-page">
      <Navbar />
      <Hero image={heroImage} minimal />

      <div
        className="page-content"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "60vh",
        }}
      >
        <div
          className="client-card"
          style={{ maxWidth: "600px", width: "100%", padding: "40px" }}
        >
          <div
            className="page-intro"
            style={{ marginBottom: "30px", textAlign: "center" }}
          >
            <p className="section-label">Get in Touch</p>
            <h2 className="section-heading" style={{ fontSize: "2rem" }}>
              Send Us a <em>Message</em>
            </h2>
            <div
              className="contact-rule"
              style={{
                margin: "15px auto",
                width: "50px",
                height: "3px",
                background: "#00e5ff",
              }}
            />
          </div>

          <p
            className="about-text"
            style={{ marginBottom: "40px", textAlign: "left" }}
          >
            Whether you have a project in mind, want to explore a partnership,
            or simply have questions — we'd love to hear from you.
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              alignItems: "flex-start",
              textAlign: "left",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div
                className="client-logo-wrap"
                style={{
                  width: "44px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0,
                }}
              >
                <Mail size={20} color="#00e5ff" />
              </div>
              <span
                className="client-name"
                style={{ fontSize: "1.05rem", margin: 0 }}
              >
                admin@softickllc.com
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div
                className="client-logo-wrap"
                style={{
                  width: "44px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0,
                }}
              >
                <MapPin size={20} color="#00e5ff" />
              </div>
              <span
                className="client-name"
                style={{ fontSize: "1.05rem", margin: 0 }}
              >
                Maryland, United States
              </span>
            </div>

            <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
              <div
                className="client-logo-wrap"
                style={{
                  width: "44px",
                  height: "44px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: 0,
                }}
              >
                <Clock size={20} color="#00e5ff" />
              </div>
              <span
                className="client-name"
                style={{ fontSize: "1.05rem", margin: 0 }}
              >
                Response within 1 business day
              </span>
            </div>
          </div>
        </div>
      </div>

      <Bottombar />
    </div>
  );
}

export default ContactForm;
